import React from "react";
import ResetPasswordPage from "./views/LoginResetPasswordPage";
import { ResetPasswordContextProvider } from "./LoginResetPasswordView";
import LoginResetPasswordContent from "../../constants/contentFile.json";
import Button from "../../components/ButtonComponent/Button";

const ResetPassword = () => {
  return (
    <ResetPasswordContextProvider>
      <ResetPasswordPage textContents={LoginResetPasswordContent.pageLoginResetPassword}/>
    </ResetPasswordContextProvider>
 
  );
};
export default ResetPassword;
